import { css } from 'emotion';

const labelValue = css`
  flex: 1;
`;

const iconWrapper = css`
  flex: 0;
  width: 17px;
`;

export default {
  labelValue,
  iconWrapper,
};
